import axios from "axios";
import { config_headers, servicelist, URL_API } from "../Config";

export const pCtGisProgressColorList = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios
                .post(URL_API(`${servicelist.CtService}p_ct_gis_progress_color_list`), body, authorization)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
export const pCtGisProgressColorUpdate = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios
                .post(URL_API(`${servicelist.CtService}p_ct_gis_progress_color_update`), body, authorization)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
